import { Buffer } from "buffer";
import React from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DownloadIcon from "@mui/icons-material/Download";
import ForwardIcon from "@mui/icons-material/Forward";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import { useCurrentAction } from "@/hooks/user";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import _ from "lodash";
import moment from "moment";

import constant from "@/config/constant";
import {
  createExpenses,
  downloadAttachment,
  updateExpenses,
} from "@/fetch/fetchExpenses";
import formatBytes from "@/lib/formatBytes";
import getExtension from "@/lib/getExtension";

export default function SubExpensesDialog(props) {
  const {
    onCancel,
    open,
    formData,
    submitButtonColor = "primary",
    onSuccess,
    productOptions,
  } = props;
  const [dialogFormData, setDialogFormData] = React.useState({
    category: "",
    product_ids: [],
  });
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [hasLocked, setHasLocked] = React.useState(false);

  const actions = useCurrentAction();
  const [error, setError] = React.useState({});
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  React.useEffect(() => {
    setDialogFormData(formData);
  }, [formData]);
  React.useEffect(() => {
    setHasLocked(_.some(dialogFormData.costs, { is_locked: true }));
  }, [dialogFormData]);
  const checkIsExist = (filename, index) => {
    let name = filename;
    const existIndex = _.findIndex(
      formData.costs[index].attachments,
      (imageData) => imageData.name === filename
    );
    if (existIndex >= 0) {
      const ext = getExtension(filename);
      const fileName = _.dropRight(filename.split(".")).join(".");
      name = `${fileName}(1).${ext}`;
      return checkIsExist(name, index);
    } else {
      return name;
    }
  };
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        const base64Data = fileReader.result.split("base64,")[1];
        resolve(base64Data);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const handleUpload = async (event, index) => {
    const costs = [...dialogFormData.costs];
    const files = event.target.files;
    if (!costs[index].attachments) {
      costs[index].attachments = [];
    }
    for (let i = 0; i < files.length; i++) {
      let name = checkIsExist(files[i].name, index);
      const base64Data = await convertBase64(files[i]);
      const buffer = Buffer.from(base64Data, "base64");
      costs[index].attachments.push({
        action: "new",
        buffer: buffer,
        name: name,
        size: files[i].size,
        type: files[i].type,
      });
    }
    setDialogFormData((prev) => {
      return {
        ...prev,
        costs,
      };
    });
  };

  const handleDownload = async (attachment) => {
    try {
      const { data: url } = await downloadAttachment(attachment);
      window.open(url, "_blank");
    } catch (error) {}
  };
  const handleDelete = async (attachment, index) => {
    const costs = [...dialogFormData.costs];

    const attachments = costs[index].attachments;

    const attachmentsIndex = _.findIndex(
      attachments,
      (a) => a.name === attachment.name
    );
    if (attachments[attachmentsIndex].action === "new") {
      _.remove(attachments, (a) => a.name === attachment.name);
    } else {
      attachments[attachmentsIndex].action = "delete";
    }
    setDialogFormData((prev) => {
      return {
        ...prev,
        costs: costs,
      };
    });
  };
  const onSubmit = async () => {
    const _error = {};
    try {
      setIsSubmitting(true);
      if (!dialogFormData.name) {
        _error["name"] = true;
      }
      if (!dialogFormData.category) {
        _error["category"] = true;
      }
      if (dialogFormData.product_ids.length <= 0) {
        _error["product_ids"] = true;
      }
      const allDate = _.sortBy(
        _.flatMap(
          _.map(dialogFormData.costs, (cost, index) => {
            if (moment(cost.start_date).isAfter(cost.end_date)) {
              _error[`${index}_start_date_not_vaild`] = true;
              _error[`${index}_end_date_not_vaild`] = true;
            }
            if (!cost.start_date) {
              _error[`${index}_start_date`] = true;
            }
            if (!cost.end_date) {
              _error[`${index}_end_date`] = true;
            }
            if (!cost.cost) {
              _error[`${index}_cost`] = true;
            }
            return [cost.start_date, cost.end_date];
          })
        )
      );
      const submitData = { ...dialogFormData };
      submitData.start_date = allDate[0];
      submitData.end_date = allDate[allDate.length - 1];
      if (!_.isEmpty(_error)) {
        setError(_error);
        throw _error;
      }
      if (submitData.id) {
        await updateExpenses(submitData.id, submitData);
      } else {
        await createExpenses(submitData);
      }

      onSuccess();
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Dialog
      open={open}
      maxWidth={"lg"}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>
        {dialogFormData.parent_name ?? dialogFormData.name}
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <Box
          component="form"
          noValidate
          sx={{
            display: "grid",
            gridTemplateColumns: { sm: "0.4fr 0.3fr 0.3fr" },
            gap: 2,
            marginBottom: 3,
          }}
        >
          <FormControl fullWidth>
            <TextField
              id="name"
              name="name"
              label="公司名稱"
              disabled={!actions?.update || hasLocked}
              error={error["name"]}
              helperText={error[`name`] ? "不能為空" : ""}
              onChange={(event) => {
                const _formData = { ...dialogFormData };
                _formData["name"] = event.target.value;
                setDialogFormData(_formData);
              }}
              value={dialogFormData.name}
              sx={{ width: "100%" }}
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              disabled={
                !actions?.update || dialogFormData.isSubExpenses || hasLocked
              }
              select
              id="category"
              name="category"
              label="類別"
              error={error["category"]}
              helperText={error[`category`] ? "請選擇類別" : ""}
              value={dialogFormData.category}
              onChange={(event) => {
                const _formData = { ...dialogFormData };
                _formData["category"] = event.target.value;
                setDialogFormData(_formData);
              }}
              sx={{ width: "100%" }}
            >
              <MenuItem disabled>請選擇</MenuItem>
              {constant.expensesCategory.map((category, index) => {
                return (
                  <MenuItem key={index} value={category}>
                    {category}
                  </MenuItem>
                );
              })}
            </TextField>
          </FormControl>
          <FormControl fullWidth>
            {actions?.update ? (
              <ProductAutoComplete
                fullWidth={true}
                multiple={true}
                disabled={
                  !actions?.update || dialogFormData.isSubExpenses || hasLocked
                }
                productOptions={productOptions}
                handleOnChange={(value) => {
                  setDialogFormData({
                    ...dialogFormData,
                    product_ids: value,
                  });
                }}
                selectedValue={dialogFormData.product_ids}
                error={error.product_ids}
              ></ProductAutoComplete>
            ) : (
              <ProductAutoComplete
                fullWidth={true}
                multiple={true}
                productOptions={_.filter(productOptions, (p) =>
                  _.includes(dialogFormData.product_ids, p.id)
                )}
                handleOnChange={() => {
                  return false;
                }}
                selectedValue={dialogFormData.product_ids}
              ></ProductAutoComplete>
            )}
          </FormControl>
        </Box>
        {_.map(dialogFormData.costs, (cost, index) => {
          const disabled =
            !actions?.update || dialogFormData.costs[index]?.is_locked;
          const is_account_checked =
            dialogFormData.costs[index]?.is_account_checked;
          return (
            <React.Fragment>
              <Box
                component="form"
                key={`cost${index}`}
                noValidate
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    sm: " 0.1fr 0.6fr 0.1fr 0.6fr 0.6fr 1fr 0.6fr 0.1fr 0.1fr",
                  },
                  gap: 2,
                  marginBottom: 2,
                  marginTop: 2,
                }}
              >
                <FormControl>
                  <IconButton
                    disabled={disabled}
                    color={"error"}
                    sx={{ mb: 1, mt: 1 }}
                    onClick={() => {
                      const _formData = { ...dialogFormData };
                      _formData.costs.splice(index, 1);
                      setDialogFormData(_formData);
                    }}
                  >
                    <DeleteForeverIcon></DeleteForeverIcon>
                  </IconButton>
                </FormControl>
                <FormControl fullWidth>
                  <DatePicker
                    label="開始日期"
                    name="start_date"
                    value={cost.start_date}
                    minDate={
                      dialogFormData.parent_id ? dialogFormData.minDate : null
                    }
                    maxDate={cost.end_date}
                    disabled={disabled}
                    onChange={(newValue) => {
                      const _formData = { ...dialogFormData };
                      _formData["costs"][index]["start_date"] =
                        moment(newValue).format("YYYY-MM-DD");
                      if (!_formData["costs"][index]["end_date"]) {
                        _formData["costs"][index]["end_date"] = moment(newValue)
                          .endOf("month")
                          .format("YYYY-MM-DD");
                      }
                      setDialogFormData(_formData);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          error[`${index}_start_date`] ||
                          error[`${index}_start_date_not_vaild`]
                        }
                        helperText={
                          error[`${index}_start_date`]
                            ? "不能為空"
                            : error[`${index}_start_date_not_vaild`]
                            ? "開始日期不能大於結束日期"
                            : ""
                        }
                        disabled={disabled}
                        sx={{ width: "100%" }}
                      />
                    )}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <IconButton
                    disabled={disabled}
                    color={"info"}
                    sx={{ mb: 1, mt: 1 }}
                  >
                    <ForwardIcon></ForwardIcon>
                  </IconButton>
                </FormControl>
                <FormControl fullWidth>
                  <DatePicker
                    label="結束日期"
                    name="end_date"
                    value={cost.end_date}
                    minDate={cost.start_date}
                    disabled={disabled}
                    onChange={(newValue) => {
                      const _formData = { ...dialogFormData };
                      _formData["costs"][index]["end_date"] =
                        moment(newValue).format("YYYY-MM-DD");
                      setDialogFormData(_formData);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={
                          error[`${index}_end_date`] ||
                          error[`${index}_end_date_not_vaild`]
                        }
                        helperText={
                          error[`${index}_end_date`]
                            ? "不能為空"
                            : error[`${index}_end_date_not_vaild`]
                            ? "結束日期不能小於開始日期"
                            : ""
                        }
                        sx={{ width: "100%" }}
                        disabled={disabled}
                      />
                    )}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    id="cost"
                    name="cost"
                    label="支出"
                    disabled={disabled}
                    error={error[`${index}_cost`]}
                    helperText={error[`${index}_cost`] ? "不能為空" : ""}
                    value={cost.cost}
                    onChange={(event) => {
                      const _formData = { ...dialogFormData };
                      _formData["costs"][index]["cost"] = event.target.value;
                      setDialogFormData(_formData);
                    }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    multiline
                    id="remark"
                    name="remark"
                    disabled={disabled}
                    label="備註"
                    onChange={(event) => {
                      const _formData = { ...dialogFormData };
                      _formData["costs"][index]["remark"] = event.target.value;
                      setDialogFormData(_formData);
                    }}
                    value={cost.remark}
                    sx={{ width: "100%" }}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      mt: 1,
                    }}
                  >
                    <Button
                      component="label"
                      disabled={disabled}
                      role={undefined}
                      tabIndex={-1}
                      startIcon={<CloudUploadIcon />}
                    >
                      上載附件
                      <VisuallyHiddenInput
                        type="file"
                        onChange={(e) => handleUpload(e, index)}
                        multiple
                      />
                    </Button>
                  </Box>
                </FormControl>
                <FormControl fullWidth>
                  {dialogFormData.costs[index]?.is_locked ? (
                    <IconButton
                      onClick={() => {
                        if (actions?.unlock) {
                          const _formData = { ...dialogFormData };
                          _formData["costs"][index]["is_locked"] = false;
                          setDialogFormData(_formData);
                        } else {
                          window.alert("權限不足");
                        }
                      }}
                      color={"error"}
                      sx={{ mb: 1, mt: 1 }}
                    >
                      <LockIcon></LockIcon>
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => {
                        if (actions?.lock) {
                          const _formData = { ...dialogFormData };
                          _formData["costs"][index]["is_locked"] = true;
                          setDialogFormData(_formData);
                        } else {
                          window.alert("權限不足");
                        }
                      }}
                      color={"success"}
                      sx={{ mb: 1, mt: 1 }}
                    >
                      <LockOpenIcon></LockOpenIcon>
                    </IconButton>
                  )}
                </FormControl>
                <FormControl fullWidth>
                  <IconButton
                    onClick={() => {
                      if (actions?.account_check || actions?.account_uncheck) {
                        if (
                          dialogFormData["costs"][index][
                            "is_account_checked"
                          ] &&
                          !actions?.account_uncheck
                        ) {
                          window.alert("權限不足");
                        } else {
                          const _formData = { ...dialogFormData };
                          _formData["costs"][index]["is_account_checked"] =
                            !dialogFormData["costs"][index][
                              "is_account_checked"
                            ];
                          setDialogFormData(_formData);
                        }
                      } else {
                        window.alert("權限不足");
                      }
                    }}
                    color={is_account_checked ? "success" : "error"}
                    sx={{ mb: 1, mt: 1 }}
                  >
                    {is_account_checked ? (
                      <MonetizationOnIcon></MonetizationOnIcon>
                    ) : (
                      <MonetizationOnOutlinedIcon></MonetizationOnOutlinedIcon>
                    )}
                  </IconButton>
                </FormControl>
              </Box>
              {dialogFormData.costs[index]?.attachments?.length > 0 && (
                <Accordion sx={{ mb: 3 }}>
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography>
                      附件(
                      {
                        _.filter(
                          dialogFormData.costs[index]?.attachments,
                          (attachment) => !attachment.isDeleted
                        ).length
                      }
                      )
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <List dense={true}>
                      {_.map(
                        dialogFormData.costs[index].attachments,
                        (attachment) => {
                          if (!attachment.isDeleted) {
                            return (
                              <ListItem
                                secondaryAction={
                                  <React.Fragment>
                                    {attachment.action !== "new" && (
                                      <IconButton
                                        edge="end"
                                        color="primary"
                                        aria-label="download"
                                        onClick={() =>
                                          handleDownload(attachment)
                                        }
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    )}
                                    <IconButton
                                      disabled={disabled}
                                      edge="end"
                                      aria-label="delete"
                                      color="error"
                                      onClick={() =>
                                        handleDelete(attachment, index)
                                      }
                                    >
                                      <DeleteForeverIcon />
                                    </IconButton>
                                  </React.Fragment>
                                }
                              >
                                <ListItemIcon>
                                  <AttachFileIcon />
                                </ListItemIcon>
                                <ListItemText
                                  style={{
                                    textDecorationLine:
                                      attachment.action === "delete"
                                        ? "line-through"
                                        : "none",
                                  }}
                                  primary={`${attachment.name} - ${formatBytes(
                                    attachment.size
                                  )}`}
                                />
                              </ListItem>
                            );
                          }
                        }
                      )}
                    </List>
                  </AccordionDetails>
                </Accordion>
              )}
            </React.Fragment>
          );
        })}
        <Button
          component="label"
          disabled={!actions?.update}
          role={undefined}
          variant="contained"
          tabIndex={-1}
          onClick={() => {
            const _formData = { ...formData };
            _formData.costs.push({
              cost: null,
              start_date: null,
              end_date: null,
              remark: "",
            });
            setDialogFormData(_formData);
          }}
          startIcon={<AddCircleIcon />}
        >
          新增
        </Button>
      </DialogContent>
      <DialogActions>
        <Button color={"error"} onClick={onCancel}>
          取消
        </Button>
        <LoadingButton
          disabled={
            !actions?.update &&
            !actions?.account_check &&
            !actions?.account_uncheck
          }
          onClick={onSubmit}
          color={submitButtonColor}
          type="submit"
          loading={isSubmitting}
        >
          儲存
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
